import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormBuilderRoute: InvariantJiraRoute = {
	name: 'software-form-builder',
	path: '/jira/software/projects/:projectKey/form/:formId/builder',
	exact: true,
};
